module.exports = __webpack_public_path__ + "img/home_exit_normal.b27bbcbf.svg";